export default __webpack_public_path__ + "static/media/avatar_53.091a47a3.png";